class AllAboutProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelector("#all-about-product--tabs");
    this.imageColumn = document.querySelector("#all-about-product--col-image");

    this.tabs.addEventListener("click", this.tabsEventHandler.bind(this));

    this.setBackgroundColor();
  }

  disconnectedCallback() {
    this.tabs.removeEventListener("click", this.tabsEventHandler.bind(this));
  }

  tabsEventHandler(event) {
    const newActiveBtn = event.target.closest(".all-about-product--tab-button");
    const { productTabHandle } = newActiveBtn.dataset;

    const prevActiveBtn = this.tabs.querySelector(
      `[data-product-tab-active="true"]`
    );
    const prevActiveTab = this.querySelector(
      `.all-about-product--tab-content[data-product-tab-handle="${prevActiveBtn.dataset.productTabHandle}"]`
    );

    prevActiveBtn.dataset.productTabActive = false;
    prevActiveTab.dataset.productTabActive = false;

    newActiveBtn.dataset.productTabActive = true;
    this.querySelector(
      `.all-about-product--tab-content[data-product-tab-handle="${productTabHandle}"]`
    ).dataset.productTabActive = true;

    this.imageColumn.querySelector(
      `div[data-image-tab-active="true"]`
    ).dataset.imageTabActive = false;
    this.imageColumn.querySelector(
      `div[data-product-tab-handle="${productTabHandle}"]`
    ).dataset.imageTabActive = true;

    this.setBackgroundColor();
  }

  setBackgroundColor() {
    document.querySelector(
      ".shopify-section.all-about-product"
    ).style.backgroundColor = this.querySelector(
      `.all-about-product--tab-content[data-product-tab-active="true"]`
    ).dataset.backgroundColor;
  }
}

class IngredientsAndSciencePopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.componentClickEventHandler.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener(
      "click",
      this.componentClickEventHandler.bind(this)
    );
  }

  componentClickEventHandler(event) {
    const openDialog = event.target.closest(".ingredients-science--popup-btn");
    const closeIngredientBtn = event.target.closest(".close-ingredient-popup");

    if (openDialog) {
      const { ingredientPopupHandle } = openDialog.dataset;
      this.querySelector(
        `dialog[data-ingredient-popup-handle="${ingredientPopupHandle}"]`
      ).showModal();
    }

    if (closeIngredientBtn) {
      closeIngredientBtn.closest("dialog").close();
    }
  }
}

customElements.define("all-about-product", AllAboutProduct);
customElements.define(
  "ingredients-and-science-popup",
  IngredientsAndSciencePopup
);
